import { render, staticRenderFns } from "./BaddeptTable.vue?vue&type=template&id=331fd41b"
import script from "./BaddeptTable.vue?vue&type=script&lang=js"
export * from "./BaddeptTable.vue?vue&type=script&lang=js"
import style0 from "./BaddeptTable.vue?vue&type=style&index=0&id=331fd41b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports